module.exports = __webpack_public_path__ + "static/jouwweb-030e177586e51eff00ac362f5b774358.svg";